// extracted by mini-css-extract-plugin
export default {"toc":"n_bB","h3toc":"n_bC","linkText":"n_bD","tocTitle":"n_bF"};